export const DesignerSettingsLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex-col h-full p-300 gap-300 overflow-y-auto">
    {children}
  </div>
);
